import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * TH Sensor Icon Style 01 - Device Thermostat (Material Symbol)
 * Always shows in orange color (sensors don't have ON/OFF state)
 * Uses outline style (FILL: 0)
 * 
 * @see https://fonts.google.com/icons?selected=Material+Symbols+Outlined:device_thermostat:FILL@0
 */
export const Style01_Thermometer: React.FC<DeviceIconProps> = ({ 
  size = 'small',
  className = '',
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = 'text-orange-500';

  return (
    <span 
      className={`material-symbols-outlined ${colorClass} ${className}`}
      style={{ 
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      device_thermostat
    </span>
  );
};

export default Style01_Thermometer;
